var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "handshake"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_286_22667",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path561",
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_286_22667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path567",
    d: "M0.758309 22.5303L5.5659 10.3441C5.71431 9.96775 6.13975 9.78297 6.51606 9.93147L10.3415 11.4407C10.7178 11.5891 10.9026 12.0145 10.7541 12.3908L5.94653 24.5772C5.79812 24.9535 5.37268 25.1382 4.99637 24.9897L1.1709 23.4806C0.79459 23.3321 0.609902 22.9067 0.758309 22.5303Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path571",
    d: "M34.4446 29.3477L31.9419 27.4193",
    stroke: "white",
    strokeWidth: 2.37305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path575",
    d: "M31.0999 32.043L28.875 30.3301",
    stroke: "white",
    strokeWidth: 2.37305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path579",
    d: "M27.4176 34.4961L25.832 33.269",
    stroke: "white",
    strokeWidth: 2.37305,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path583",
    d: "M10.7036 30.4652C9.92059 29.8012 9.82403 28.6283 10.488 27.8453L12.226 25.8052C12.8899 25.0222 14.0629 24.9257 14.8458 25.5896C15.6288 26.2534 15.7254 27.4263 15.0615 28.2093L13.3234 30.2495C12.6595 31.0325 11.4866 31.1291 10.7036 30.4652Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path587",
    d: "M13.5375 32.8695C12.7545 32.2055 12.6581 31.0326 13.3219 30.2496L15.06 28.2095C15.7239 27.4265 16.8969 27.33 17.6799 27.9939C18.4629 28.6577 18.5594 29.8307 17.8955 30.6136L16.1574 32.6538C15.4934 33.4368 14.3205 33.5334 13.5375 32.8695Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path591",
    d: "M16.3725 35.2738C15.5895 34.6098 15.493 33.4369 16.1569 32.6539L17.895 30.6137C18.5589 29.8308 19.7319 29.7343 20.5149 30.3982C21.2978 31.062 21.3943 32.2349 20.7304 33.0179L18.9924 35.0581C18.3284 35.8411 17.1555 35.9377 16.3725 35.2738Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path595",
    d: "M19.2119 37.678C18.4289 37.0141 18.3323 35.8412 18.9963 35.0582L20.7343 33.0181C21.3982 32.2351 22.5712 32.1385 23.3541 32.8025C24.1371 33.4663 24.2337 34.6392 23.5698 35.4222L21.8317 37.4624C21.1678 38.2454 19.9949 38.342 19.2119 37.678Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path599",
    d: "M37.5658 26.4077L36.6309 25.7178L32.2341 22.4728L31.7303 22.1186C27.5794 22.8237 24.7966 20.5493 23.6638 19.3665C23.3306 19.0185 22.7807 19.0053 22.4223 19.3272C18.5301 22.8229 16.2761 21.9269 15.1818 20.887C14.6556 20.3871 14.7461 19.5252 15.3571 19.1331C17.4491 17.7903 19.4027 16.0907 20.7985 14.7661L20.55 14.673C19.6664 14.3419 18.7378 14.1466 17.7958 14.0936L15.2217 13.9491C14.8846 13.9301 14.5464 13.9259 14.2095 13.9476C13.6019 13.9866 12.9919 13.885 12.4275 13.6489L10.5639 12.8691L5.99316 24.4548L9.60657 26.7336L10.7501 27.5375L12.2253 25.8061C12.8891 25.023 14.062 24.9265 14.845 25.5904C15.628 26.2543 15.7246 27.4272 15.0607 28.2102C15.7246 27.4272 16.8975 27.3306 17.6805 27.9946C18.4635 28.6585 18.5601 29.8314 17.8961 30.6144C18.5601 29.8314 19.733 29.7349 20.516 30.3988C21.299 31.0626 21.3955 32.2356 20.7316 33.0186C21.3955 32.2356 22.5684 32.1391 23.3514 32.8029C24.1344 33.4669 24.231 34.6399 23.5671 35.4228L22.8621 36.2503L24.4139 37.3956C25.2758 38.0316 26.4903 37.9586 27.2303 37.1843C27.9505 36.4308 27.9935 35.2964 27.4177 34.4967L28.1958 35.0709C29.0832 35.7259 30.3401 35.6254 31.0695 34.7982C31.7761 33.9969 31.7582 32.8213 31.0984 32.0425L31.5355 32.365C32.3817 32.9895 33.571 32.9329 34.3155 32.1901C35.1069 31.4004 35.1279 30.1633 34.4473 29.3479L35.1036 29.8323C36.021 30.5092 37.3129 30.3354 38.0179 29.4334C38.7539 28.4916 38.5276 27.1175 37.5658 26.4077Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path603",
    d: "M27.0451 13.2883L24.3762 12.8653C23.4733 12.7221 22.5558 13.0211 21.9131 13.6712C20.5888 15.0109 18.0896 17.3765 15.3549 19.1318C14.7439 19.524 14.6533 20.3857 15.1796 20.8858C16.2738 21.9256 18.5278 22.8215 22.4201 19.3259C22.7785 19.004 23.3283 19.0172 23.6616 19.3652C24.7963 20.55 27.5859 22.8302 31.7478 22.1144L38.0053 26.7324L41.9162 24.2203L37.4501 12.8994L34.7356 13.9015C33.9828 14.1794 33.1712 14.2593 32.3786 14.1337L30.3055 13.8051",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path607",
    d: "M44.2918 15.0422L42.4382 10.344C42.2898 9.9678 41.8644 9.78302 41.4881 9.93143L37.6626 11.4406C37.2863 11.5891 37.1016 12.0146 37.25 12.3908L42.0576 24.5771C42.206 24.9535 42.6315 25.1381 43.0078 24.9897L46.8332 23.4806C47.2096 23.3321 47.3943 22.9067 47.2458 22.5304L45.4974 18.0984",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv2);
export default __webpack_public_path__ + "static/media/adv2.a19ee5f66ed78e99fb6e81d6c71abcaa.svg";
export { ForwardRef as ReactComponent };